module.exports = __webpack_public_path__ + "img/home-rbn-5.11b19b35.png";